import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatDateTime } from "@/lib/format";
import PageHeader from "@/components/PageHeader";
import DataTable from "@/components/DataTable";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit-logs").then((r) => setRows(r.data)); }, []);

  const columns = [
    { key: "timestamp", label: "Waktu", sortable: true, render: (r) => formatDateTime(r.timestamp) },
    { key: "user_name", label: "User", render: (r) => <span>{r.user_name}<div className="text-xs text-slate-400">{r.user_role}</div></span> },
    { key: "aktivitas", label: "Aktivitas", sortable: true, render: (r) => <span className="font-medium text-slate-800">{r.aktivitas}</span> },
    { key: "pegawai", label: "Pegawai / Entity", render: (r) => r.pegawai || r.entity || "-" },
    {
      key: "detail", label: "Perubahan", render: (r) => (
        <div className="text-xs text-slate-500 max-w-xs truncate">
          {r.data_lama && <span className="text-rose-500">{JSON.stringify(r.data_lama)}</span>}
          {r.data_baru && <span className="text-emerald-600"> → {JSON.stringify(r.data_baru)}</span>}
        </div>
      ),
    },
  ];
  return (
    <div className="space-y-6">
      <PageHeader title="Audit Log" subtitle="Catatan seluruh aktivitas penting sistem" />
      <DataTable columns={columns} data={rows} searchKeys={["aktivitas", "user_name", "pegawai"]} pageSize={20} testid="audit-table" />
    </div>
  );
}
